/**
 * @file 直播等级
 */
;(function(win, UpAct) {
    const COLORS = [
        'rgba(146,208,0,0.7)', //color0
        'rgba(255,135,164,0.7)', //color1
        'rgba(255,78,111,0.7)', //color2
        'rgba(255,174,0,0.7)', //color3
        'rgba(255,47,66,0.7)', //color4
        'rgba(255,53,165,0.7)', //color5
        'rgba(255,0,78,0.7)', //color6
        'rgba(201,0,1,0.7)', //color7
        'rgba(181,48,255,0.7)', //color8
        'rgba(175,2,212,0.7)', //color9
        'rgba(56,136,255,0.7)', //color10
        'rgba(24,21,255,0.7)', //color11
        'rgba(164,57,255,0.7)', //color12
        'rgba(112,0,211,0.7)', //color13
        'rgba(20,197,255,0.7)', //color14
        'rgba(14,99,255,0.7)', //color15
        'rgba(165,97,255,0.7)', //color16
        'rgba(255,0,64,0.7)', //color17
        'rgba(192,0,22,0.7)', //color18
        'rgba(200,75,231,0.7)', //color19
        'rgba(148,35,255,0.7)', //color20
        'rgba(255,206,8,0.7)', //color21
        'rgba(255,126,0,0.7)', //color22
        'rgba(255,0,0,0.7)', //color23
        'rgba(140,0,204,0.7)' //color24
    ];

    let defaultCfg = {
        'selector': '[node-id=grade]', //img 样式名称
        'dataGrade': 'data-grade'
    };

    let gradeNodeList;

    const gradeHelper = {
        getGradeIndex: function(grade) {
            if (grade < 1) {
                return 0;
            }

            let x = grade;

            let n = 0;

            if (x < 44) {
                //等级小于44的时候每个区间的『等级差值』是一个等差数列
                //利用等差数列求和公式和求根公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (Math.sqrt(9 + 8 * x) - 3) / 2;
            } else {
                //等级大于等于44的时候每个区间的『等级』是一个等差数列
                //利用等差数列通项公式来计算当前等级所在区间对应到图片存放的地方的坐标；输出0123456.....
                n = (x - 34) / 10;
                //与44级之前的对接
                n += 7;
            }

            return Math.floor(n);
        },
        start: function() {
            getGradeNodeList();
            handleGrade();
        }
    };

    function getGradeNodeList() {
        gradeNodeList = Array.prototype.slice.call(document.querySelectorAll(defaultCfg.selector));
    }

    function handleGrade() {
        let gradeAttr = defaultCfg.dataGrade;

        if (gradeNodeList.length > 0) {
            gradeNodeList.forEach(function(el, index) {
                if (el.getAttribute('data-grade-checked') != 'true') {
                    let dataGrade = el.getAttribute(gradeAttr);

                    if (typeof dataGrade  !=='undefined' ) {
                        let index = gradeHelper.getGradeIndex(dataGrade);
                        let color = COLORS[index];
                        let gradeCls = 'grade_' + index;
                        let htmlArr = [
                            '<i class="' + gradeCls + '"></i>',
                            '<em style="background-color: ' + color + '">' + dataGrade + '</em>'
                        ];
                        el.innerHTML = htmlArr.join('');
                        el.setAttribute('data-grade-checked', 'true');
                        el.removeAttribute(gradeAttr);
                    }
                }
            });
        }
    }

    const _init = function(options) {
        options = options || {};

        defaultCfg = $.extend(defaultCfg, options);

        gradeHelper.start();
    }

    UpAct.grade = function() {
        _init.apply(gradeHelper, arguments);
        return gradeHelper;
    }

})(window, window['UpAct'] || (window['UpAct'] = {}));



// WEBPACK FOOTER //
// ./js/lib/util/grade.js